import { SK } from './storageKeys'

// The registry (src/lib/storageKeys.ts) owns the literal; this re-export keeps
// existing import sites on constants.ts unchanged.
export const ACTIVE_ORG_KEY = SK.activeOrg

export const DEPLOYMENT_POLL_MS = 3000
export const TRAINING_POLL_MS = 5000
// Eval run poll — frontend-contract.md §6.3 says 2-5s; report is null until completed.
export const EVAL_POLL_MS = 3000

// Contracts page — order/balance transitions are operator-driven (/admin
// routes, human cadence); queries poll only while an order is non-terminal.
export const CONTRACTS_POLL_MS = 15000

// 注册/登录临时关闭开关 — 构建时烘焙（改 .env 后需重新构建）。true 时落地页
// 隐藏注册/登录入口，/login 与 /register 只渲染维护提示（AuthClosedNotice）。
// 注意：这只关 UI，不封 API —— 需要真正拦截请求时在 nginx/backend 侧配合。
export const AUTH_CLOSED = ['true', '1', 'on', 'yes'].includes(
  String(import.meta.env.VITE_AUTH_CLOSED ?? '').toLowerCase(),
)

// 注册单独关闭开关 — 构建时烘焙（改 .env 后需重新构建）。与 AUTH_CLOSED 的分工：
// 那一个连登录一起关（整站维护）；这一个只关注册 —— 落地页隐藏注册入口、
// /register 只渲染「注册暂未开放」提示，/login 照常可用（登录仍开放）。
// prod 的权威侧是后端的 AUTH_REGISTRATION_OPEN：它关掉 /auth/phone/register
// （403 auth.REGISTRATION_CLOSED），控制台只负责把这件事说出来。
export const REGISTRATION_CLOSED = ['true', '1', 'on', 'yes'].includes(
  String(import.meta.env.VITE_REGISTRATION_CLOSED ?? '').toLowerCase(),
)

// Upload pipeline (src/lib/upload.ts): hard gate, single-PUT → multipart cutover,
// proposed part size (server res.partSize wins), part PUT fan-out.
export const MAX_UPLOAD_BYTES = 100 * 1024 ** 3 // 100 GiB
export const MULTIPART_THRESHOLD = 128 * 1024 ** 2 // 128 MiB
export const UPLOAD_PART_SIZE = 64 * 1024 ** 2 // 64 MiB
export const UPLOAD_PART_CONCURRENCY = 4
